import React from 'react';
import cx from 'classnames';
import Base from './Base';


const TertiaryButton = ({className, ...props }) => <Base {...props} className={cx('btn--secondary', className)} />;

export default TertiaryButton;
